import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueScrollShow from 'vue-scroll-show'
import VueGtm from '@gtm-support/vue2-gtm';
import VueTyperPlugin from 'vue-typer'
import VueCarousel from 'vue-carousel';
import AOS from 'aos';
import CollapseTransition from '@ivanv/vue-collapse-transition'

Vue.use(VueScrollShow)

// Vue.use(VueTagManager, {
//   gtmId: 'GTM-WDXJKSV'
// })

Vue.use(VueTyperPlugin)

AOS.init();

Vue.use(VueCarousel);

Vue.component('CollapseTransition', CollapseTransition)

Vue.use(VueGtm, {
  id: 'GTM-P8W5Q9Z',
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
